import styled from "styled-components";
import React from "react";
import { useSidebar } from "@/components/ui/sidebar";
import { useLocation } from "react-router-dom";
import { useHomeScroll } from "@/contexts/HomeScrollContext";

const Container = styled.div<{ isExpanded: boolean }>`
  width: ${props => props.isExpanded ? 'auto' : '32px'};
  height: 32px;
  aspect-ratio: ${props => props.isExpanded ? 'auto' : '1/1'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Img = styled.img<{ isExpanded: boolean; useGreyFilter?: boolean }>`
    width: ${props => props.isExpanded ? 'auto' : '32px'};
    height: 32px;
    padding: ${props => props.isExpanded ? '0 4px' : '0'};
    filter: ${props => props.useGreyFilter ? 'brightness(0) saturate(100%) invert(80%) sepia(0%) saturate(0%) hue-rotate(179deg) brightness(92%) contrast(85%)' : 'none'};
`;

// We need to allow this component to pass the HTML attributes.
interface AnystayLogoSidebarProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function AnystayLogoSidebar(props: AnystayLogoSidebarProps) {
    const { state } = useSidebar();
    const location = useLocation();
    const { isHomeScrolled } = useHomeScroll();
    const isExpanded = state === "expanded";
    
    const isHomePage = location.pathname === "/";
    const useGreyFilter = isHomePage && !isHomeScrolled;
    
    const logoSrc = isExpanded 
        ? (useGreyFilter 
            ? "https://d292awxalydr86.cloudfront.net/Branding/Anystay_white.svg"
            : "https://d292awxalydr86.cloudfront.net/Branding/Anystay.svg")
        : (useGreyFilter
            ? "https://d292awxalydr86.cloudfront.net/Branding/Anystay_logo_small_white.svg"
            : "https://d292awxalydr86.cloudfront.net/Branding/Anystay+logo+small.svg");
    
    return (
        <Container isExpanded={isExpanded} {...props}>
            <Img isExpanded={isExpanded} useGreyFilter={useGreyFilter} src={logoSrc} alt="Anystay Logo" />
        </Container>
    )
}